import { BlockRegistry, type BlockDefinition, type RegistryOptions } from "@broadpaper/core";
import { sectionBlock, rowBlock, columnBlock, repeaterItemBlock } from "./blocks/structure.js";
import { headingBlock, textBlock, imageBlock, logoBlock, dividerBlock, spacerBlock, buttonBlock, calloutBlock, quoteBlock, fieldBlock, kpiBlock, signatureBlock, dateBlock, pageNumberBlock, timestampBlock } from "./blocks/content.js";
import { containerBlock, cardBlock, pageBreakBlock, keepTogetherBlock, conditionalBlock, repeaterBlock } from "./blocks/layout.js";
import { tableBlock, keyValueListBlock } from "./blocks/table.js";
import { chartBlock, progressBlock } from "./blocks/charts.js";

export * from "./blocks/structure.js";
export * from "./blocks/content.js";
export * from "./blocks/layout.js";
export * from "./blocks/table.js";
export * from "./blocks/charts.js";
export * from "./charts/chart-svg.js";

/** Every built-in block, in palette order. */
export const builtInBlocks: Array<BlockDefinition<any>> = [
  // structure
  sectionBlock,
  rowBlock,
  columnBlock,
  repeaterItemBlock,
  // content
  headingBlock,
  textBlock,
  imageBlock,
  logoBlock,
  dividerBlock,
  spacerBlock,
  buttonBlock,
  calloutBlock,
  quoteBlock,
  signatureBlock,
  dateBlock,
  pageNumberBlock,
  timestampBlock,
  // layout
  containerBlock,
  cardBlock,
  pageBreakBlock,
  keepTogetherBlock,
  // data
  fieldBlock,
  kpiBlock,
  keyValueListBlock,
  conditionalBlock,
  repeaterBlock,
  tableBlock,
  // visualisation
  chartBlock,
  progressBlock
];

/** Creates a registry with every built-in block plus any custom blocks. */
export function createRegistry(custom: Array<BlockDefinition<any>> = [], opts: RegistryOptions = {}): BlockRegistry {
  return new BlockRegistry([...builtInBlocks, ...custom], opts);
}
